// src/hooks/useChrome.js
// Lets a deeply-nested page hide the global app chrome (Navbar + Footer) —
// used by MintLink Plus branded checkouts, which take over the full screen.
import React, { createContext, useContext, useEffect, useState } from 'react';

const ChromeContext = createContext({ hidden: false, setHidden: () => {} });

export const ChromeProvider = ({ children }) => {
  const [hidden, setHidden] = useState(false);
  return (
    <ChromeContext.Provider value={{ hidden, setHidden }}>
      {children}
    </ChromeContext.Provider>
  );
};

export const useChromeState = () => useContext(ChromeContext);

// Call with `true` to hide Navbar/Footer while the calling page is mounted.
export const useFullscreenPage = (active) => {
  const { setHidden } = useContext(ChromeContext);
  useEffect(() => {
    if (!active) return undefined;
    setHidden(true);
    return () => setHidden(false);
  }, [active, setHidden]);
};
